export default "__VITE_ASSET__DlAqpCo1__"